import { render, staticRenderFns } from "./podcast-list.vue?vue&type=template&id=5687bb86&scoped=true&"
import script from "./podcast-list.vue?vue&type=script&lang=js&"
export * from "./podcast-list.vue?vue&type=script&lang=js&"
import style0 from "./podcast-list.vue?vue&type=style&index=0&id=5687bb86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687bb86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VImg,VProgressCircular})
